import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgTextComponent } from './svgtext.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgTextComponent],
  exports: [SvgTextComponent]
})
export class SvgTextModule { }
